import React from 'react';
import {TrackingProvider} from '@ezcater/tracking-react';
import ScreenInfo from './ScreenInfo';

export default ({children}) =>
  typeof window === 'undefined' ? (
    children
  ) : (
    <ScreenInfo>
      {screen => (
        <TrackingProvider
          appName="ezManage"
          project="ez_manage"
          browserWidth={screen.innerWidth}
          browserHeight={screen.innerHeight}
          pixelRatio={screen.devicePixelRatio}
        >
          {children}
        </TrackingProvider>
      )}
    </ScreenInfo>
  );
